<!--
 * @Author: your name
 * @Date: 2019-10-24 20:32:55
 * @Description: In User Settings Edit
 -->
<template>
  <div>
    <el-dialog lock-scroll :modal-append-to-body="false" :append-to-body="true" :title="$lang('编辑订单')" custom-class="j-dialog"
               :close-on-click-modal="false" top="45px" :visible.sync="visible" @close="close" width="960px">
      <div class="overflow">
        <el-form class="el-form-edit" ref="orderForm" :rules="rules" :inline="true" :model="formData" label-position="left"
                 label-suffix=" :">
          <!-- <div class="group-title" style="padding:0 0 16px 0;" v-show="comeFrom==='order'">
            <span class="title">寄件人信息</span>
          </div> -->
          <h3 v-show="comeFrom==='order'">{{ $lang('寄件人信息') }}</h3>
          <div class="group-content" v-show="comeFrom==='order'">
            <el-form-item :label="$lang('姓名')" prop="senderName">
              <el-input v-model="formData.senderName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('手机')" prop="senderMobilePhone">
              <!-- <el-input v-model="formData.senderMobilePhone" :placeholder="$lang('请输入')" :maxlength='15'></el-input> -->
              <BasePhoneInput :value="phoneVal1" v-model="formData.senderMobilePhone"></BasePhoneInput>
            </el-form-item>
            <el-form-item :label="$lang('公司')" prop="senderCompany">
              <template slot="label"><span :title="$lang('公司')">{{ $lang('公司') }}</span></template>
              <el-input v-model.trim="formData.senderCompany" :placeholder="$lang('请输入公司')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item :label="$lang('邮编')" id="areaCodeSty">
              <template slot="label"><span :title="$lang('邮编')">{{ $lang('邮编') }}</span></template>
              <el-input v-model.trim="formData.senderPostalCode" :minlength="1" :maxlength="10"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('邮箱')" id="areaCodeSty">
              <template slot="label"><span :title="$lang('邮箱')">{{ $lang('邮箱') }}</span></template>
              <el-input v-model.trim="formData.senderEmail" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="senderProvinceName" prop="senderProvinceName">
              <el-select filterable v-model="formData.senderProvinceName" @change="dataProvinceChange($event,1)">
                <el-option
                  v-for="item in provinceArray"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="senderCityName" prop="senderCityName">
              <el-select filterable v-model="formData.senderCityName" @change="dataCityChange($event,1)">
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="senderAreaName" prop="senderAreaName" v-if="countryId === 1">
              <el-select filterable v-model="formData.senderAreaName" @change="dataAreaChange($event,1)">
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('寄件街道')" prop="senderStreet">
              <el-input v-model.trim="formData.senderStreet" :placeholder="$lang('请输入')" :minlength="1" :maxlength="12"></el-input>
            </el-form-item>
            <el-tooltip :disabled="senderShortAddressDisabled" class="item" effect="dark" placement="bottom-start">
              <div slot="content" style="cursor: pointer;max-width: 250px;" @click="handleCopy(senderShortAddressParseResults)">
                {{ senderShortAddressParseResults }}
              </div>
              <el-form-item v-if="countryId === 1" :label="$lang('寄件短地址')" prop="senderShortAddress">
                <el-input v-model="formData.senderShortAddress" :placeholder="$lang('请输入寄件短地址')" :minlength="1" :maxlength="8" @blur="judgeShortAddress('senderShortAddressParseResults', 'senderShortAddress')" />
              </el-form-item>
            </el-tooltip>
            <el-form-item v-if="countryId === 1" :label="$lang('寄件建筑物编号')" prop="senderBuildingNumber">
              <template slot="label"><span :title="$lang('寄件建筑物编号')">{{ $lang('寄件建筑物编号') }}</span></template>
              <el-input v-model="formData.senderBuildingNumber" :placeholder="$lang('请输入寄件建筑物编号')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item v-if="countryId === 1" :label="$lang('寄件辅助编号')" prop="senderReferenceNumber">
              <template slot="label"><span :title="$lang('寄件辅助编号')">{{ $lang('寄件辅助编号') }}</span></template>
              <el-input v-model="formData.senderReferenceNumber" :placeholder="$lang('请输入寄件辅助编号')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <!-- <el-form-item :label="$lang('省/市/区')" prop="senderProvince">
              <BaseAddress ref="senderProvinceSearch" :showLevel="3" :initAddressData="sendAddressData" v-model="formData.senderProvince">
              </BaseAddress>
            </el-form-item> -->

            <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="senderDetailedAddress">
              <el-input v-model="formData.senderDetailedAddress" :placeholder="$lang('请输入')" :minlength="4" :maxlength="200"></el-input>
            </el-form-item>
          </div>
          <!-- <div class="group-title">
            <span class="title">收件人信息</span>
          </div> -->
          <h3>{{ $lang('收件人信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('姓名')" prop="receiverName">
              <el-input v-model="formData.receiverName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('联系电话')" prop="receiverMobilePhone">
              <!-- <el-input v-model="formData.receiverMobilePhone" :placeholder="$lang('请输入')" :maxlength='15'></el-input> -->
              <BasePhoneInput :value="phoneVal2" v-model="formData.receiverMobilePhone"></BasePhoneInput>
            </el-form-item>
            <el-form-item :label="$lang('收件人备用手机号码')" prop="receiverTelphone">
              <BasePhoneInput :value="receiverTelphone" v-model="formData.receiverTelphone"></BasePhoneInput>
            </el-form-item>
            <el-form-item :label="$lang('公司')" prop="receiverCompany">
              <template slot="label"><span :title="$lang('公司')">{{ $lang('公司') }}</span></template>
              <el-input v-model="formData.receiverCompany" :placeholder="$lang('请输入公司')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item :label="$lang('邮编')" id="areaCodeSty">
              <template slot="label"><span :title="$lang('邮编')">{{ $lang('邮编') }}</span></template>
              <el-input v-model.trim="formData.receiverPostalCode" :minlength="1" :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('邮箱')" id="areaCodeSty">
              <template slot="label"><span :title="$lang('邮箱')">{{ $lang('邮箱') }}</span></template>
              <el-input v-model.trim="formData.receiverEmail" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('省/市/区')" prop="receiverProvince">
              <BaseAddress ref="receiverProvinceSearch" :showLevel="3" :initAddressData="receiverAddressData"
                v-model="formData.receiverProvince"> </BaseAddress>
            </el-form-item> -->
            <el-form-item :label="receiverProvinceName" prop="receiverProvinceName">
              <el-select filterable v-model="formData.receiverProvinceName" :key="formData.receiverProvinceId" @change="dataProvinceChange($event,2)">
                <el-option
                  v-for="item in provinceArray"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="receiverCityName" prop="receiverCityName">
              <el-select filterable v-model="formData.receiverCityName" @change="dataCityChange($event,2)">
                <el-option
                  v-for="item in cityList2"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('收件区域')" prop="receiverAreaName" v-if="countryId === 1">
              <el-select filterable v-model="formData.receiverAreaName" @change="dataAreaChange($event,2)">
                <el-option
                  v-for="item in areaList2"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('收件街道')" prop="receiverStreet">
              <el-input v-model.trim="formData.receiverStreet" :placeholder="$lang('请输入收件街道')" :minlength="1" :maxlength="20"></el-input>
            </el-form-item>
            <el-tooltip :disabled="receiverShortAddressDisabled" class="item" effect="dark" placement="bottom-start">
              <div slot="content" style="cursor: pointer;max-width: 250px;" @click="handleCopy(receiverShortAddressParseResults)">
                {{ receiverShortAddressParseResults }}
              </div>
              <el-form-item v-if="countryId === 1" :label="$lang('收件短地址')" prop="receiverShortAddress">
                <div class="label-tip" slot="label">
                  <span :title="$lang('收件短地址')">{{ $lang('收件短地址') }}</span>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content" class="short-tips">
                      <div>{{ $lang('Short address is a project from Saudi Arabia goverment.') }}</div>
                      <div>{{ $lang(' Introduction') }}:</div>
                      <a href="https://splonline.com.sa/en/national-address-1/" target="_blank">https://splonline.com.sa/en/national-address-1/</a>
                      <div>{{ $lang('Map for National address') }}:</div>
                      <a href="https://maps.splonline.com.sa" target="_blank">https://maps.splonline.com.sa</a>
                    </div>
                    <img class="tooltip-click" src="@/assets/images/exclamation-mark-icon.svg" alt="">
                  </el-tooltip>
                </div>
                <el-input v-model="formData.receiverShortAddress" :placeholder="$lang('请输入收件短地址')" :minlength="1" :maxlength="8" @blur="judgeShortAddress('receiverShortAddressParseResults', 'receiverShortAddress')" />
              </el-form-item>
            </el-tooltip>
            <el-form-item v-if="countryId === 1" :label="$lang('收件辅助编号')" prop="receiverReferenceNumber">
              <template slot="label"><span :title="$lang('收件辅助编号')">{{ $lang('收件辅助编号') }}</span></template>
              <el-input v-model="formData.receiverReferenceNumber" :placeholder="$lang('请输入收件辅助编号')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item v-if="countryId === 1" :label="$lang('收件建筑物编号')" prop="receiverBuildingNumber">
              <template slot="label"><span :title="$lang('收件建筑物编号')">{{ $lang('收件建筑物编号') }}</span></template>
              <el-input v-model="formData.receiverBuildingNumber" :placeholder="$lang('请输入收件建筑物编号')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
              <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请输入')" :minlength="4" :maxlength="200"></el-input>
            </el-form-item>
          </div>
          <!-- <div class="group-title">
            <span class="title">货物信息</span>
          </div> -->
          <h3>{{ $lang('货物信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('件数')" prop="packageNumber">
              <el-input-number v-model="formData.packageNumber" label="描述文字" :step="1" :precision="0" :min="1" :max="999"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('物品类型')" prop="goods">
              <Base-Select v-model="formData.goods" :props="{label:'name',value:'code', res:'appArticleTypeVOList',valueObj:true}"
                           dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')"></Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('物品名称')" prop="goodsName">
              <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="100"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('物品重量')" prop="packageTotalWeight">
              <el-input-number v-model="formData.packageTotalWeight" label="描述文字" :precision="2" :min="0" :max="99999.99"></el-input-number>
            </el-form-item>
            <!-- <el-form-item :label="$lang('产品类型')" prop="payType">
              <Base-Select v-model="formData.payType" :dic="DIC.payType" :placeholder="$lang('请选择')"></Base-Select>
            </el-form-item> -->
            <el-form-item :label="$lang('结算方式')" prop="payment">
              <Base-Select v-model="formData.payment" :disabled="true" :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"
                           dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')">
              </Base-Select>
              <!-- <Base-Select v-model="formData.payment" :dic="DIC.payTypes" :placeholder="$lang('请选择')"
                :props="{label:'name',value:'code',valueObj:true}"></Base-Select> -->
            </el-form-item>
            <el-form-item :label="$lang('产品类型')" prop="expressType">
              <Base-Select v-model="formData.expressType" :props="{label:'productName',value:'productCode', res:'appProductTypeVOList',valueObj:true}"
                           :dic="someExpressTypeData" :placeholder="$lang('请选择')">
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('参考运费')" prop="standardValue">
              <el-input v-model="formData.standardValue" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('箱材规格')" prop="boxStandard">
              <Base-Select v-model="formData.boxStandard" :props="{label:'name',value:'id', res:'records',valueObj:true}"
                dicUrl="/vip/material/getMaterialSalesPrice" :placeholder="$lang('请选择')" @change="changeBoxStandard">
              </Base-Select>
            </el-form-item> -->
            <!-- <el-form-item label="箱子数量" prop="boxNumber">
              <el-input-number v-model="formData.boxNumber"  :step="1" :precision="0" :min="0" :max="99"></el-input-number>
            </el-form-item> -->
            <!-- <el-form-item label="箱子单价">
              <el-input v-model="formData.boxPrice" disabled></el-input>
            </el-form-item> -->
            <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
              <el-input v-model="formData.customerOrderId" :placeholder="$lang('请输入')" :minlength="1" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('是否购买赔偿上限服务')" prop="insured" class="insured-info">
              <Base-Select :disabled="!insureSwitch" v-model="formData.insured" :dic="insuredDic" :clearable="false" :placeholder="$lang('请选择')" @change="changeInsured" :props="{label:'name' ,value:'code'}"></Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('货物价值')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
              <!-- <el-input  @keyup.enter.native="searchData(false)" v-model="formData.declaredValue" :placeholder="$lang('请输入')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input> -->
              <el-input-number v-model="formData.declaredValue" :placeholder="$lang('请输入')" :step="1" :precision="0" :controls="false" :min="0" :max="8000"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('赔偿上限服务费')" prop="insuredValue" v-show="formData.insured===1">
              <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>
            <br>
            <!-- <el-form-item :label="$lang('备注')" prop="remarks" style="width:860px;">
              <el-input type="textarea" v-model="formData.remarks" :maxlength="50" :label="$lang('描述文字')"></el-input>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('是否签回单')" prop="signReceipt">
              <template slot="label"> <span :title="$lang('是否签回单')">{{$lang('是否签回单')}}</span></template>
              <Base-Select :clearable="false"
                v-model="formData.signReceipt"
                :dic="signReceiptDic"
                :placeholder="$lang('请选择')"
                @change="changeSignReceipt"
                :props="{label:'name' ,value:'code'}">
                </Base-Select>
            </el-form-item> -->
            <el-form-item :label="$lang('代收货款币别')" prop="codCurrencyTypeName">
              <el-select v-model="formData.codCurrencyTypeName" :disabled="true" >
                <el-option
                  v-for="item in codCurrencyType"
                  :key="item.codCurrencyTypeCode"
                  :label="item.codCurrencyTypeName"
                  :value="item.codCurrencyTypeCode"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('代收货款金额')" prop="codMoney">
              <el-input v-model="formData.codMoney" :label="$lang('描述文字')" :disabled="codIsInput" :placeholder="$lang('请输入对应的金额')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('平台')" prop="platformName">
              <el-input v-model.trim="formData.platformName" :placeholder="$lang('请输入电商平台名称')" :minlength="1" :maxlength="10"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('客户账号')" prop="customerAccount">
              <el-input class="customerStyle" v-model.trim="formData.customerAccount" :placeholder="$lang('请输入电商平台客户账号')" :minlength="1" :maxlength="10"></el-input>
            </el-form-item>
            <el-form-item style="width: auto;margin-top: 20px;" prop="isUnpackEnabled">
              <el-switch
                v-model="formData.isUnpackEnabled"
                :active-text="$lang('是否允许客户开箱验视')"
              >
              </el-switch>
            </el-form-item>
            <br>
            <el-form-item :label="$lang('备注')" prop="remarks" style="width:860px;">
              <el-input type="textarea" v-model="formData.remarks" :maxlength="50" :label="$lang('描述文字')"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <!-- <el-button @click="close">{{ $lang('取消') }}</el-button> -->
        <el-button type="primary" :loading="keyBtn" @click="sumbit" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
      <InsuredStatement :infoVisible="infoVisible" @closeInsured="closeInsured"></InsuredStatement>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
import { DIC } from '@constants'
import { mapGetters } from 'vuex'
import {
  RULES,
  phoneAndMobile,
  checkAddressFormat,
  integerWeight,
  isNullObj,
  checkGoodsName
} from '@/utils/rules'
import {
  getComCost,
  getSettlement,
  getComputationCost,
  getsysCurrencyType,
  getList,
  getShortAddress,
  judgeShortAddress
} from '@/api/module/customer'
import InsuredStatement from '@components/dialog/InsuredStatement'
import debounce from 'lodash/debounce'
import * as Api from '@api/base/public'
import { copyText } from '@/utils/util'

export default {
  name: 'EditOrder',
  components: {
    InsuredStatement,
  },
  props: {
    value: {},
    orderData: {
      type: Object,
      default: function () {
        return {}
      },
    },
    comeFrom: {
      type: String,
      default: function () {
        return 'order'
      },
    },
    disablePayment: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      DIC,
      keyBtn: false,
      data: '',
      visible: false,
      infoVisible: false, // 赔偿上限服务费声明弹窗
      cityList: [],
      cityList2: [],
      areaList: [],
      areaList2: [],
      phoneVal1: '',
      phoneVal2: '',
      codIsInput: false,
      receiverTelphone: '',
      provinceArray: [],
      codFlag: false,
      codCurrencyType: [],
      formData: {
        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderCompany: '', // 寄件人公司
        senderPostalCode: '', // 寄件邮编
        senderEmail: '', // 寄件邮箱
        senderProvince: {},
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域id,
        senderStreet: '', // 寄件区域名称,
        // senderLocal: '', // 寄件区省/市/区
        senderDetailedAddress: '', // 寄件详细地址,
        receiverName: '', // 收件人姓名,
        receiverMobilePhone: '', // 收件人手机号,
        receiverTelphone: '', // 收件人备用手机号
        receiverCompany: '', // 收件人公司
        receiverPostalCode: '', // 收件人邮编
        receiverEmail: '', // 收件人邮箱
        receiverProvince: {},
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverAreaName: '', // 收件区域id,
        receiverStreet: '', // 收件区域名称,

        // receiverLocal: '', // 收件区省/市/区
        receiverDetailedAddress: '', // 收件详细地址,
        insured: 0, // 是否购买赔偿上限服务1是，0否,
        declaredValue: '', // 物品价值,
        insuredValue: '', // 赔偿上限服务费,
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 0, // 物品重量,
        packageNumber: 1, // 物品件数,
        payment: { code: 'PP_PM', name: 'PP_PM', id: 42 }, // 结算方式
        // payment: '', // 结算方式
        paymentModeId: '42', // 结算方式id,
        paymentModeCode: 'PP_PM', // 结算方式编码,
        paymentModeName: 'PP_PM', // 结算方式名称,
        expressType: '', // 产品类型
        expressTypeCode: '', // 产品类型code
        expressTypeName: '', // 产品类型name
        codMoney: '', // COD,
        codFee: 0, // COD手续费,
        standardValue: 0, // 参考运费,
        boxNumber: 1, // 箱材数量,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        signReceipt: 0, // 签回单 0否 1是
        // receiptFreight: 0, // 回单金额
        codCurrencyTypeName: 'SAR', // 代收货款币别
        codCurrencyTypeCode: 'SAR', // 代收货款币别code
        boxPrice: 0, // 箱材单价,
        remarks: '', // 备注,
        settlementWeight: 0, // 结算重量
        packageChargeWeight: 1, // 结算重量,
        customerOrderId: '',
        platformName: '', // 平台
        customerAccount: '', // 客户账号
        isUnpackEnabled: false,
        taxation: 0, // 税率
        senderShortAddress: '', // 寄件短地址
        receiverShortAddress: '', // 收件端地址
      },
      rules: {},
      prodectData: [], // 产品list
      insuredDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      signReceiptDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      sendAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      startAddressId: null,
      endAddressId: null,
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      senderProvinceName: this.$lang('省份'),
      senderCityName: this.$lang('寄件城市'),
      senderAreaName: this.$lang('寄件区域'),
      receiverProvinceName: this.$lang('省份'),
      receiverCityName: this.$lang('收件城市'),
      senderExpressTypeData: [],
      receiverExpressTypeData: [],
      senderShortAddressParseResults: '', // 寄件短地址解析结果
      receiverShortAddressParseResults: '', // 收件短地址解析结果
    }
  },
  watch: {
    'countryCode': {
      handler(val) {
        const that = this
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          that.senderProvinceName = this.$lang('寄件酋长国')
          that.senderCityName = this.$lang('寄件区域')
          that.receiverProvinceName = this.$lang('收件酋长国')
          that.receiverCityName = this.$lang('收件区域')
        }
      },
      immediate: true,
    },
    comeFrom: {
      handler(val) {
        if (val === 'order') {
          this.rules = {
            senderName: [RULES.requiredTrim],
            senderMobilePhone: [RULES.required, { validator: phoneAndMobile }],
            // senderProvince: [RULES.requiredSelect],
            senderProvinceName: [RULES.requiredSelect],
            senderCityName: [RULES.requiredSelect],
            // senderStreet: [RULES.requiredTrim],
            receiverProvinceName: [RULES.requiredSelect],
            codMoney: [{ validator: this.codMoneyRule }],
            receiverCityName: [RULES.requiredSelect],
            // receiverAreaName: [RULES.requiredSelect],
            // receiverStreet: [RULES.requiredTrim],
            senderDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
            receiverName: [RULES.requiredTrim],
            receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
            receiverTelphone: [{ validator: phoneAndMobile }],
            receiverProvince: [RULES.requiredSelect, { validator: isNullObj }],
            receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
            goods: [RULES.requiredSelect],
            goodsName: [RULES.required, { validator: checkGoodsName }],
            packageTotalWeight: [RULES.required, { validator: integerWeight }],
            payment: [RULES.requiredSelect],
            insured: [RULES.requiredSelect],
            expressType: [RULES.requiredSelect],
            senderShortAddress: [RULES.codeNumber],
            senderBuildingNumber: [RULES.twenty],
            senderReferenceNumber: [RULES.twenty],
            receiverShortAddress: [RULES.codeNumber],
            receiverReferenceNumber: [RULES.twenty],
            receiverBuildingNumber: [RULES.twenty],
            // packageNumber: [RULES.required],
          }
        } else {
          this.rules = {
            receiverName: [RULES.requiredTrim],
            receiverMobilePhone: [RULES.requiredTrim, { validator: phoneAndMobile }],
            receiverTelphone: [{ validator: phoneAndMobile }],
            receiverProvince: [RULES.requiredSelect, { validator: isNullObj }],
            receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
            codMoney: [{ validator: this.codMoneyRule }],
            goods: [RULES.requiredSelect],
            goodsName: [RULES.required, { validator: checkGoodsName }],
            packageTotalWeight: [RULES.required, { validator: integerWeight }],
            payment: [RULES.requiredSelect],
            expressType: [RULES.requiredSelect],
            insured: [RULES.requiredSelect],

            // senderProvinceName: [RULES.requiredSelect],
            // senderCityName: [RULES.requiredSelect],
            // senderStreet: [RULES.requiredTrim],
            receiverProvinceName: [RULES.requiredSelect],
            receiverCityName: [RULES.requiredSelect],
            // receiverAreaName: [RULES.requiredSelect],
            // receiverStreet: [RULES.requiredTrim],
            // packageNumber: [RULES.required],
          }
        }
      },
      immediate: true,
    },
    value: {
      handler(val) {
        this.visible = val
      },
      immediate: true,
    },
    orderData: {
      handler(val) {
        // 箱材规格 初始化
        // debugger
        const boxStandard = {
          id: val.boxStandardId,
          materialCode: val.boxStandardCode,
          materialName: val.boxStandardName,
          boxPrice: val.boxPrice,
          salesPrice: val.boxPrice,
          name: val.boxStandardName,
          code: val.boxStandardCode,
        }
        const goods = {
          id: val.goodsTypeId,
          code: val.goodsTypeCode,
          name: val.goodsTypeName,
        }
        const payment = {
          id: 42 || val.paymentModeId,
          code: 'PP_PM' || val.paymentModeCode,
          name: 'PP_PM' || val.paymentModeName,
        }
        let expressType = {
          productCode: val.expressTypeCode, // 产品类型code
          productName: val.expressTypeName, // 产品类型name
        }
        val.isUnpackEnabled = !!val.isUnpackEnabled
        if (Object.keys(expressType).some(key => !expressType[key])) expressType = ''
        const receiverTelphone = val.receiverTelphone || ''
        this.formData = { ...val, boxStandard, goods, payment, expressType, receiverTelphone }
        console.log(this.formData, val)
        this.handleProvice(this.formData.senderProvinceId, 1)
        this.handleProvice(this.formData.receiverProvinceId, 2)
        this.getCurrencyTypeList()
        if (this.countryId === 1) {
          if (this.formData.senderShortAddress) {
            this.judgeShortAddress('senderShortAddressParseResults', 'senderShortAddress')
          }
          if (this.formData.receiverShortAddress) {
            this.judgeShortAddress('receiverShortAddressParseResults', 'receiverShortAddress')
          }
        }
        // 初始化 箱材规格
      },
      deep: true,
    },
    someExpressTypeData: {
      handler(arr) {
        // const newArr = arr.filter(item => item.productCode !== 'Reverse')
        const newArr = arr
        if (newArr && newArr.length) {
          if (!this.formData.expressType) {
            this.formData.expressType = newArr[0]
            this.formData.expressTypeCode = newArr[0].productCode
            this.formData.expressTypeName = newArr[0].productName
          }
        } else {
          if (this.receiverExpressTypeData.length > 0 && this.senderExpressTypeData.length > 0) {
            this.formData.expressType = []
            this.formData.expressTypeId = ''
            this.formData.expressTypeCode = ''
            this.formData.expressTypeName = ''
            this.$message.error(this.$lang('产品类型不匹配，无法下单'))
          }
        }
      },
      deep: true,
      immediate: true,
    },
    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val || {}
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured, expressTypeCode } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        // let paramNum = 0
        // if (!this.formData.taxation && this.formData.taxation !== 0) {
        //   paramNum = 0
        // } else {
        //   paramNum = this.formData.taxation
        // }
        // const resNum = Math.round(parseFloat(res) * (parseFloat(paramNum) / 100 + 1) * 100) / 100
        // console.log('uuuuu2', resNum)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
      }
    },
    // 支付方式
    async 'formData.payment'(val) {
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val || {}
      Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
      const { senderProvince, receiverProvince, packageTotalWeight } = this.formData
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      // 到付现结不支持赔偿上限服务
      if (val.name === '到付现结') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
      }
    },
    async 'formData.expressType'(val) {
      const { productCode, productName } = val
      console.log('formData.expressType--产品类型-->', productCode, productName)
      const taxationVal = this.prodectData.find(item => item.code === productCode)
      this.formData.taxation = taxationVal ? taxationVal.taxRate : 0
      console.log('this.formData.taxation--税率-->', this.formData.taxation)
      Object.assign(this.formData, { expressTypeCode: productCode, expressTypeName: productName })
      const { senderCityName, receiverCityName, packageTotalWeight } = this.formData
      if (senderCityName && receiverCityName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      const res = await this.getComputationCost(this.formData)
      // let paramNum = 0
      // if (!this.formData.taxation && this.formData.taxation !== 0) {
      //   paramNum = 0
      // } else {
      //   paramNum = this.formData.taxation
      // }
      // const resNum = Math.round(parseFloat(res) * (parseFloat(paramNum) / 100 + 1) * 100) / 100
      // console.log('uuuuu3', resNum)
      Object.assign(this.formData, { insuredValue: res })
      this.$refs.orderForm.validateField('codMoney')
    },

    // 运费计算
    async 'formData.senderCityName'(val) {
      const { receiverCityName, packageTotalWeight } = this.formData
      if (receiverCityName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 运费计算
    async 'formData.receiverCityName'(val) {
      const { senderCityName, packageTotalWeight } = this.formData
      if (senderCityName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 物品重量
    async 'formData.packageTotalWeight'(val) {
      const { senderCityName, receiverCityName } = this.formData
      if (senderCityName && receiverCityName && val > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 赔偿上限服务费计算
    async 'formData.declaredValue'(val) {
      const { goods, insured, expressTypeCode } = this.formData
      if (insured === 1 && goods && parseFloat(val) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        // let paramNum = 0
        // if (!this.formData.taxation && this.formData.taxation !== 0) {
        //   paramNum = 0
        // } else {
        //   paramNum = this.formData.taxation
        // }
        // const resNum = Math.round(parseFloat(res) * (parseFloat(paramNum) / 100 + 1) * 100) / 100
        // console.log('uuuuu4', resNum)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
    },

  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    insureSwitch() {
      return (this.$store.state.base.user || {}).insureSwitch === 1
    },
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    },
    countryId() {
      return this.$store.state.base.user.countryId || ''
    },
    someExpressTypeData() {
      return this.receiverExpressTypeData.filter(i => this.senderExpressTypeData.some(j => j.productCode === i.productCode))
    },
    isReverse() {
      const { expressTypeCode } = this.formData
      return expressTypeCode === 'Reverse' || expressTypeCode === `Reverse${this.countryCode}` || expressTypeCode === 'ReverseKW'
    },
    senderShortAddressDisabled() {
      return !(this.senderShortAddressParseResults)
    },
    receiverShortAddressDisabled() {
      return !(this.receiverShortAddressParseResults)
    }
  },
  created() {
    this.getProList()
    this.getList()
    // if (this.formData.insured === 1) { // 是否购买赔偿上限服务1是，0否,
    //   this.rules.declaredValue = [RULES.required, RULES.declaredValue]
    // }
  },
  mounted() {
    this.calcStandardCost(this.formData)
  },
  methods: {
    codMoneyRule(rule, value, callback) {
      console.log('codMoney', value)
      if (value && this.isReverse && value !== '0') {
        console.log('codMoney', value)
        callback(new Error('COD orders not allowed for product Reserve'))
      } else
      if (this.isReverse && (!value || value === '0')) {
        this.codIsInput = true
        this.formData.codCurrencyTypeName = ''
        this.formData.codCurrencyTypeCode = ''
        this.formData.codMoney = ''
        callback()
      } else {
        this.codIsInput = false
        callback()
      }
    },
    async judgeShortAddress(type, prop) {
      try {
        const { senderShortAddress, receiverShortAddress } = this.formData
        const params = {
          shortAddress: type === 'senderShortAddressParseResults' ? senderShortAddress : receiverShortAddress
        }
        if (!params.shortAddress) {
          this[type] = ''
          this.formData[prop] = ''
          return
        }
        const regex = /^[A-Za-z]{4}\d{4}$/
        if (!regex.test(params.shortAddress)) {
          this.formData[prop] = ''
          this.$message.error(this.$lang('不符合短地址规则'))
          return
        }
        const { code, data } = await judgeShortAddress(params)
        if (code === RESPONSE_SUCCESS && data && data === true) {
          this.getShortAddress(type)
        } else {
          this[type] = ''
          this.formData[prop] = ''
          this.$message.error(this.$lang('未找到该短地址对应的地址，请核实后重试。'))
        }
      } catch (error) {
        this[type] = ''
      }
    },
    // 解析短地址
    async getShortAddress(type) {
      try {
        const { senderShortAddress, receiverShortAddress } = this.formData
        const params = {
          shortAddress: type === 'senderShortAddressParseResults' ? senderShortAddress : receiverShortAddress
        }
        if (!params.shortAddress) {
          this[type] = ''
          return
        }
        const { code, data, msg } = await getShortAddress(params)
        if (code === RESPONSE_SUCCESS) {
          this[type] = data || ''
        } else {
          this[type] = ''
          this.$message.error(msg)
        }
      } catch (error) {
        this[type] = ''
      }
    },
    // 复制短地址解析结果
    handleCopy(data) {
      copyText(data)
      this.$message.success(this.$lang('复制成功'))
    },
    openInsured() {
      this.infoVisible = true
    },
    closeInsured() {
      this.infoVisible = false
    },
    async changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.insuredValue = 0
        this.formData.declaredValue = ''
      }
      const { goods, declaredValue, expressTypeCode } = this.formData
      if (val === 1 && goods && declaredValue && parseFloat(declaredValue) && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        // let paramNum = 0
        // if (!this.formData.taxation && this.formData.taxation !== 0) {
        //   paramNum = 0
        // } else {
        //   paramNum = this.formData.taxation
        // }
        // const resNum = Math.round(parseFloat(res) * (parseFloat(paramNum) / 100 + 1) * 100) / 100
        // console.log('uuuuu5', resNum)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
    },
    dataCityChange(value, num) {
      if (num === 1) {
        this.formData.senderCityId = value
        const obj = this.cityList.find((item) => {
          return item.id === value
        })
        this.formData.senderCityName = obj.nativeName
        this.senderExpressTypeData = obj.products || []
        this.formData.senderAreaId = ''
        this.formData.senderCityName = ''
      } else {
        this.formData.receiverCityId = value
        const obj = this.cityList2.find((item) => {
          return item.id === value
        })
        this.formData.receiverCityName = obj.nativeName
        this.formData.receiverAreaId = ''
        this.formData.receiverAreaName = ''
        this.receiverExpressTypeData = obj.products || []
      }
      this.getAreaList(value, num)
    },
    dataAreaChange(value, flag) {
      if (flag === 1) {
        this.formData.senderAreaId = value
        const obj = this.areaList.find((item) => {
          return item.id === value
        })
        this.formData.senderAreaName = obj.nativeName
      } else {
        this.formData.receiverAreaId = value
        const obj = this.areaList2.find((item) => {
          return item.id === value
        })
        this.formData.receiverAreaName = obj.nativeName
      }
    },
    changeBoxStandard(val) {
      if (!val) {
        this.formData.boxPrice = 0
      }
      if (val && val.salesPrice) {
        const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
        Object.assign(this.formData, {
          // 箱材规格id
          boxStandardId,
          // 箱材规格名称
          boxStandardName,
          // 箱材单价
          boxPrice,
        })
      }
    },
    // 获取基础数据
    async getList() {
      const { data, code, msg } = await getList()
      if (code === RESPONSE_SUCCESS) {
        this.prodectData = data['appProductTypeVOList']
        console.log(555555, this.prodectData)
      } else {
        this.$message.error(msg)
      }
    },
    async getAreaList(parentId, flag) {
      const { data, code, msg } = await Api.GET_AREANEW({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        if (flag === 1) {
          this.areaList = data
          this.formData.senderAreaId = data[0].id
          this.formData.senderCityName = data[0].nativeName
        } else {
          this.areaList2 = data
          this.formData.receiverAreaId = data[0].id
          this.formData.receiverAreaName = data[0].nativeName
        }
      } else {
        this.$message.error(msg)
      }
    },

    // 获取酋长国数据
    async getProList() {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        // 过滤掉Reverse的产品类型数据
        // data.forEach(item => {
        //   item.products = item.products.filter(item => item.productCode !== 'Reverse') || []
        // })
        this.provinceArray = data
        console.log(this.provinceArray)
      } else {
        this.$message.error(msg)
      }
    },

    dataProvinceChange(value, flag) {
      console.log(value)
      this.getCityList(value, flag)
      if (flag === 1) {
        this.formData.senderAreaId = ''
        this.formData.senderCityName = ''
      } else {
        this.formData.receiverAreaId = ''
        this.formData.receiverAreaName = ''
      }
    },

    // 获取数据
    async getCityList(parentId, flag) {
      // const { data, code, msg } = await this.$selectApi.reqSysArea({ parentId })
      // debugger
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        // 过滤掉Reverse的产品类型数据
        // data.forEach(item => {
        //   item.products = item.products.filter(item => item.productCode !== 'Reverse') || []
        // })
        if (flag === 1) {
          this.cityList = data
          this.formData.senderProvinceId = parentId
          this.formData.senderCityId = data[0].id
          this.formData.senderCityName = data[0].nativeName
          this.getAreaList(data[0].id, flag)
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.formData.senderProvinceName = obj.nativeName
          this.senderExpressTypeData = data[0].products || []
        } else {
          this.cityList2 = data
          this.formData.receiverProvinceId = parentId
          this.formData.receiverCityId = data[0].id
          this.formData.receiverCityName = data[0].nativeName
          this.getAreaList(data[0].id, flag)
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.formData.receiverProvinceName = obj.nativeName
          this.receiverExpressTypeData = data[0].products || []
        }
        console.log(this.cityList)
        console.log(this.someExpressTypeData)
        if (this.someExpressTypeData && this.someExpressTypeData.length) {
          this.formData.expressType = this.someExpressTypeData[0]
          this.formData.expressTypeCode = this.someExpressTypeData[0].productCode
          this.formData.expressTypeName = this.someExpressTypeData[0].productName
        } else {
          this.formData.expressType = ''
          this.formData.expressTypeCode = ''
          this.formData.expressTypeName = ''
          if (this.receiverExpressTypeData.length && this.senderExpressTypeData.length) {
            this.$message.error(this.$lang('产品类型不匹配，无法下单'))
          }
        }
      } else {
        this.$message.error(msg)
      }
    },
    async sumbit() {
      if (this.formData.insured === 1 && (!this.formData.declaredValue || parseFloat(this.formData.declaredValue) <= 0)) {
        this.$message.error(this.$lang('货物价值必须大于0'))
        return
      }
      if (this.isReverse) {
        this.formData.productDescription = 'Reverse' // 产品类型: 退货
        this.formData.returnType = 1 // 退货订单
      } else {
        this.formData.productDescription = '' // 产品类型: 默认
        this.formData.returnType = 0 // 普通下单
      }
      this.$emit('editSave', this.formData)
    },
    close() {
      this.$emit('editClose', false)
    },
    // 运费计算
    calcStandardCost: debounce(async function (data) {
      const { senderProvinceId, senderCityId, receiverCityId, receiverProvinceId, packageTotalWeight, paymentModeId, expressTypeCode } = data
      // const result = {
      //   // 寄件省份id
      //   senderProvinceId: senderProvince.provinceId,
      //   // 寄件省份名称
      //   senderProvinceName: senderProvince.provinceName,
      //   // 寄件城市id
      //   senderCityId: senderProvince.cityId,
      //   // 寄件城市名称
      //   senderCityName: senderProvince.cityName,
      //   // 寄件区域id
      //   senderAreaId: senderProvince.areaId,
      //   // 寄件区域名称
      //   senderStreet: senderProvince.areaName,
      //   // 收件省份id
      //   receiverProvinceId: receiverProvince.provinceId,
      //   // 收件省份名称
      //   receiverProvinceName: receiverProvince.provinceName,
      //   // 收件城市id
      //   receiverCityId: receiverProvince.cityId,
      //   // 收件城市名称
      //   receiverCityName: receiverProvince.cityName,
      //   // 收件区域id
      //   receiverAreaId: receiverProvince.areaId,
      //   // 收件区域名称
      //   receiverStreet: receiverProvince.areaName,
      // }
      // 运费
      const obj = {}
      const promises = [
        // 获取起始地址ID
        this.getSettlement(senderProvinceId, senderCityId),
        // 获取目的地地址ID
        this.getSettlement(receiverProvinceId, receiverCityId),
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      // 如果起始地址且目的地地址ID存在
      if (startAddressId && endAddressId && expressTypeCode) {
        // 获取运费
        const res = await this.getComCost(packageTotalWeight, startAddressId, endAddressId, paymentModeId, expressTypeCode)
        obj.standardValue = res.cost
        obj.settlementWeight = res.setWeight
        this.formData.standardValue = res.cost
      }
      // 返回结果
      return {
        // ...result,
        ...obj,
      }
    }, 200),
    // 获取币别  sysCurrencyType/list
    async getCurrencyTypeList() {
      const { data, code, msg } = await getsysCurrencyType()
      var dataList = []
      if (code === RESPONSE_SUCCESS) {
        for (let p = 0; p < data.length; p++) {
          dataList.push({ codCurrencyTypeCode: data[p].coding, codCurrencyTypeName: data[p].name })
        }
        console.log(dataList)
        this.codCurrencyType = dataList
        if (this.formData.codMoney && !this.isReverse) {
          this.formData.codCurrencyTypeName = this.codCurrencyType[0].codCurrencyTypeName // 代收货款币别
          this.formData.codCurrencyTypeCode = this.codCurrencyType[0].codCurrencyTypeCode // 代收货款币别code
        }
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 是否签回单
     */
    changeSignReceipt(val) {
      this.formData.signReceipt = val
    },
    // 查询数据
    async handleProvice(provinceId, flagType) {
      // async getCityInfo (provinceId, flagType) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        // data.forEach(item => {
        //   item.products = item.products.filter(item => item.productCode !== 'Reverse') || []
        // })
        if (flagType === 1) {
          // 过滤掉Reverse的产品类型数据
          this.cityList = data
          const item = data.find(({ id }) => id === this.formData.senderCityId)
          if (item) this.senderExpressTypeData = item.products || []
        } else {
          this.cityList2 = data
          const item = data.find(({ id }) => id === this.formData.receiverCityId)
          if (item) this.receiverExpressTypeData = item.products || []
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement(providerId, cityId, areaId, packageTotalWeight, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === 1 && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 运费计算
    async getComCost(number, startAddressId, endAddressId, paymentModeId, productTypeCode) {
      let smMode = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 320:
            smMode = 1
            break
          case 319:
            smMode = 2
            break
          case 321:
            smMode = 3
            break
        }
      }
      const reqData = { startAddressId, endAddressId, number, smMode, productTypeCode, serviceMethodCode: '01' }
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    // 赔偿上限服务费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code,
        productTypeCode: param.expressTypeCode
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
  },
}
</script>

<style lang="scss" scoped>
.group-title {
  border-bottom: 1px dashed #eeeeee;
  // margin-bottom: 20px;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;

  .title {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #e0bd7b;
  }

  .insert-info {
    display: inline-block;
    margin-left: 60px;
    position: relative;

    .icon {
      color: #e0bd7b;
      position: absolute;
      overflow: visible;
    }

    .text {
      color: #666666;
      margin-left: 20px;
    }
  }
}

.el-form-item {
  padding: 0px 8px 18px 8px !important;
}

.group-content {
  background: #f7f7f9;
  padding: 20px 20px 10px;
  border-radius: 8px;
}

.w360 .el-input {
  width: 360px !important;
}
</style>
<style lang="scss">
.el-dialog__wrapper .el-dialog.j-dialog {
  margin-bottom: 0 !important;
}

.el-dialog__wrapper .el-dialog.j-dialog .el-dialog__body {
  max-height: 700px;
  overflow: auto;
  padding: 10px 20px;

  .dialog-footer {
    border-top: 0;
    margin-top: 0px;
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
.el-form.el-form-edit .el-form-item.insured-info .el-form-item__content {
  position: relative;

  .btn-insured {
    // color: #2D7CFF;
    color: #e60012;;
    font-size: 12px;
    cursor: pointer;
    position: absolute;
    right: 24px;
    top: -94px;
    display: inline-block;
    height: 22px;
    line-height: 16px;

    &:hover {
      text-decoration: underline;
    }
  }
}
.label-tip {
  display: flex;
  align-items: center;
}
.tooltip-click {
  cursor: pointer;
  width: 16px;
  height: 16px;
  margin: 0 5px;
}
.short-tips {
  a {
    color: #28CFFE;
  }
}
</style>
